export class AppError {
    errorNumber?: string;
    message: string;
    friendlyMessage: string;
}
  